<template>
    <select
        ref="input"
        class="border-gray-300 focus:border-allday-dark-500 focus:ring-allday-dark-500 rounded-md shadow-sm mt-1 block w-full disabled:cursor-not-allowed disabled:bg-gray-200 disabled:border-gray-700" :value="modelValue"
        @change="$emit('update:modelValue', $event.target.value)"
    >
        <slot></slot>
    </select>
</template>

<script setup>
import { ref } from 'vue';

defineProps({
    modelValue: [String, Number],
});

defineEmits(['update:modelValue']);

const input = ref(null);
</script>
